export default __webpack_public_path__ + "static/media/Shaka_particle_final_11.204c0e14.png";